import { Node, nodeInputRule } from '@tiptap/core'
import { Suggestions, replaceText } from '../plugins/Suggestions'
import emojis from '@/core/emojis'

const EMOJI_REGEXP = /:([\w-]+):$/

export const Emoji = Node.create({
  name: 'emoji',

  defaultOptions: {
    matcher: {
      char: ':',
      allowSpaces: true,
      startOfLine: false
    }
  },

  addAttributes () {
    return {
      data: {
        default: null
      }
    }
  },

  inline: true,
  selectable: false,
  group: 'inline',

  parseHTML () {
    return [
      {
        tag: 'span[type="emoji"]',
        getAttrs: dom => ({
          data: dom.getAttribute('data')
        })
      }
    ]
  },

  renderHTML ({ node }) {
    return ['span', { type: 'emoji', data: node.attrs.data }, `${node.attrs.data}`]
  },

  addInputRules () {
    return [
      nodeInputRule(EMOJI_REGEXP, this.type, match => {
        const emoji = Object.keys(emojis).includes(match[1].toLowerCase()) ? emojis[match[1].toLowerCase()] : undefined

        return emoji ? { data: emoji.char } : null
      })
    ]
  },

  addProseMirrorPlugins () {
    return [
      Suggestions({
        command: ({ range, attrs, schema }) => replaceText(range, schema.nodes.emoji, attrs),
        appendText: ' ',
        matcher: this.options.matcher,
        items: () => Object.values(emojis),
        onEnter: this.options.onEnter,
        onChange: this.options.onChange,
        onExit: this.options.onExit,
        onKeyDown: this.options.onKeyDown,
        onFilter: this.options.onFilter
      })
    ]
  }
})
